import Nullstack from 'nullstack';
export default function IconRating14Plus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-rating-14-plus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("path", {
    d: "M7 15v-6"
  }), "   ", Nullstack.element("path", {
    d: "M15.5 12h3"
  }), "   ", Nullstack.element("path", {
    d: "M17 10.5v3"
  }), "   ", Nullstack.element("path", {
    d: "M12.5 15v-6m-2.5 0v4h3"
  }), " ");
}